/**
 * Farbe für einen `CanBusStatus.state` (Statusleiste und Bus Statistics).
 * Gegenstück zu `Win11Theme::BusStateColor()`, gleiche Literale.
 */

/** Grün Active, Gelb Warning, Bernstein Passive/Bus Error, Rot Bus Off. */
export function busStateColor(state: string, available: boolean): string | null {
  if (!available || state.length === 0) return null;
  if (state.includes('Off')) return 'rgb(224,48,48)';
  if (state.includes('Passive')) return 'rgb(224,138,32)';
  if (state.includes('Warning')) return 'rgb(217,196,30)';
  if (state.includes('Active')) return 'rgb(32,176,80)';
  // Alles andere ist ein adapterspezifischer Fehlertext, kein OK-Zustand.
  return 'rgb(224,138,32)';
}
